// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-MainScreen__wrapper--f32WN","dropdowns":"src-components-MainScreen__dropdowns--2Z5fR","dropdown":"src-components-MainScreen__dropdown--1zmLy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MainScreen.scss
// module id = 83
// module chunks = 0